export default __webpack_public_path__ + "static/media/Introducing Our Newest Member.c6dd7ee7.png";